import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EstimateFiltersModel, EstimateModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { IEstimatesService } from "services/EstimatesService";

const initialState = {
  Estimates: new Array<EstimateModel>(),
  IncludeArchived: false,
  LoadingEstimates: false,
};

export const estimatesTableSlice = createSlice({
  name: "estimates",
  initialState,
  reducers: {
    setIncludeArchived: (state, action) => {
      state.IncludeArchived = action.payload;
    },
    resetData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEstimates.pending, (state) => {
        state.LoadingEstimates = true;
      })
      .addCase(getEstimates.fulfilled, (state, action) => {
        state.Estimates = action.payload;
        state.LoadingEstimates = false;
      })
      .addCase(getEstimates.rejected, (state) => {
        state.LoadingEstimates = false;
      });
  },
});

export const { setIncludeArchived, resetData } = estimatesTableSlice.actions;

export const getEstimates = createAsyncThunk("estimates/GetEstimates", async (includeArchived: boolean) => {
  const estimatesService = container.get<IEstimatesService>(SERVICE_TYPES.EstimatesService);
  const estimateFilterModel = new EstimateFiltersModel({ includeArchived });
  return await estimatesService.getEstimates(estimateFilterModel);
});

export const selectEstimates = (state: RootState) => state.estimates.Estimates;
export const selectIncludeArchived = (state: RootState) => state.estimates.IncludeArchived;
export const selectLoadingEstimates = (state: RootState) => state.estimates.LoadingEstimates;

export default estimatesTableSlice.reducer;
